// Application mutation imports.
import { APPLICATION_LOADING } from 'vx/mutations'

// Application state.
const state = {
  loading: false
}

// Application state getters.
const getters = {}

// Application actions.
const actions = {
  setApplicationLoading ({ commit }, loading) {
    commit(APPLICATION_LOADING, loading)
  }
}

// Application state mutations.
const mutations = {
  [APPLICATION_LOADING] (state, loading) {
    state.loading = loading
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
